import request from "../request"

/**
 * 获取系统配置
 * @param {*}  
 * @returns 
 */
const getConfig = () => request.get(`/v1/nf/open/config`)

/**
 * 上传
 * @param {*} file 
 * @returns 
 */
const uploadFile = (file) => request.uploadFile('/v1/nf/open/file/upload', { file })

/**
 * 获取站内用户基本信息-open
 * @param {*}  
 * @returns 
 */
const getUserBasic = (uid) => request.get(`/v1/nf/open/user/info/${uid}`)

const sys = {
    getConfig,
    uploadFile,
    getUserBasic,
}

export default sys
